import {DatePipe}              from '@angular/common';
import {Component, input}      from '@angular/core';
import {CoachingLogOutputIntf} from '@djsharkk/logr-types';

@Component({
			   selector   : 'app-asst-summarizer-message',
			   imports    : [
				   DatePipe
			   ],
			   templateUrl: './asst-summarizer-message.component.html',
			   styleUrl   : './asst-summarizer-message.component.css'
		   })
export class AsstSummarizerMessageComponent {
	msg = input.required<CoachingLogOutputIntf>();
}
